import { Routing } from '../Routes';
import { useParams, match } from 'react-router-dom';
import { useApi, Res, fetchResourceMap, isNotFound } from '../../state/api';
import { Main } from '../Main/Main';
import { useTranslation } from '../../i18n/i18n';
import { useEffect, useState } from 'react';
import { LinkListingFilter } from '../../components/LinkListingFilter/LinkListingFilter';
import { Helmet } from 'react-helmet-async';
import { LoaderPage } from './LoaderPage';
import { NotFoundPage } from './NotFoundPage';

type UrlParams = { letter: string };

export const ProductsAoPage = (): JSX.Element => {
	const t = useTranslation().productsAo;
	const urls = useTranslation().routes;
	const { letter } = useParams<UrlParams>();
	const [sortedListings, setSortedListings] = useState<{ url: string; name: string }[]>([]);

	const { data: productData = [], error, isLoading } = useApi(Res.productsAo, { letter });

	useEffect(() => {
		const sorted = Object.entries(productData)
			.map((product) => ({
				url: '/' + product[1].path,
				name: product[1].name,
				id: product[1].id,
			}))
			.sort(function (a, b) {
				const aName = a.name.toLowerCase();
				const bName = b.name.toLowerCase();
				return aName < bName ? -1 : aName > bName ? 1 : 0;
			});

		setSortedListings(sorted);
	}, [productData.toString()]);

	// only a real not-found earns the not-found page; a hiccup upstream keeps the loader
	if (isNotFound(error)) return <NotFoundPage />;
	if (error || !productData) return <LoaderPage />;

	return (
		<Main>
			<Helmet>
				<title>{t.products + ' ' + letter.toUpperCase() + t.titleShortSuffix}</title>
			</Helmet>
			<h1>{t.productsAo}</h1>
			<LinkListingFilter
				searchLabel={t.searchLabel}
				itemUrl={urls.productsAO}
				isLoading={isLoading}
				links={sortedListings}
			/>
		</Main>
	);
};

export const productsAoRouting: Routing<UrlParams> = {
	path(urls) {
		return `${urls.productsAO}/:letter`;
	},
	component: ProductsAoPage,
	requiresAuth: false,
	preload: async (config, routeMatch: match<UrlParams>) => {
		const { letter } = routeMatch.params;
		return fetchResourceMap(config, Res.productsAo, { letter });
	},
};
